var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOval62ASelected = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 60 70",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M0 35c0-7.732 6.268-14 14-14h32c7.732 0 14 6.268 14 14s-6.268 14-14 14H14C6.268 49 0 42.732 0 35Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#C1A36E",
  fillRule: "evenodd",
  d: "M46 23H14C7.373 23 2 28.373 2 35s5.373 12 12 12h32c6.627 0 12-5.373 12-12s-5.373-12-12-12Zm-32-2C6.268 21 0 27.268 0 35s6.268 14 14 14h32c7.732 0 14-6.268 14-14s-6.268-14-14-14H14Z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M20.666 13.5a2.5 2.5 0 0 1-2.5 2.5H6.5A2.5 2.5 0 0 1 4 13.5v-10A2.5 2.5 0 0 1 6.5 1h14.166v12.5ZM38.334 13.5a2.5 2.5 0 0 1-2.5 2.5H24.166a2.5 2.5 0 0 1-2.5-2.5V1h16.666v12.5ZM56 13.5a2.5 2.5 0 0 1-2.5 2.5H41.833a2.5 2.5 0 0 1-2.5-2.5V1H53.5A2.5 2.5 0 0 1 56 3.5v10Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#C1A36E",
  fillRule: "evenodd",
  d: "M4 12a1 1 0 0 1-1-1V3.5A3.5 3.5 0 0 1 6.5 0h47A3.5 3.5 0 0 1 57 3.5V11a1 1 0 1 1-2 0V3.5A1.5 1.5 0 0 0 53.5 2h-47A1.5 1.5 0 0 0 5 3.5V11a1 1 0 0 1-1 1Z",
  clipRule: "evenodd"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M39.334 56.5a2.5 2.5 0 0 1 2.5-2.5H53.5a2.5 2.5 0 0 1 2.5 2.5v10a2.5 2.5 0 0 1-2.5 2.5H39.334V56.5ZM21.666 56.5a2.5 2.5 0 0 1 2.5-2.5h11.667a2.5 2.5 0 0 1 2.5 2.5V69H21.667V56.5ZM4 56.5A2.5 2.5 0 0 1 6.5 54h11.667a2.5 2.5 0 0 1 2.5 2.5V69H6.5A2.5 2.5 0 0 1 4 66.5v-10Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#C1A36E",
  fillRule: "evenodd",
  d: "M56 58a1 1 0 0 1 1 1v7.5a3.5 3.5 0 0 1-3.5 3.5h-47A3.5 3.5 0 0 1 3 66.5V59a1 1 0 1 1 2 0v7.5A1.5 1.5 0 0 0 6.5 68h47a1.5 1.5 0 0 0 1.5-1.5V59a1 1 0 0 1 1-1Z",
  clipRule: "evenodd"
})));
SvgOval62ASelected.viewBox = '0 0 60 70';
const ForwardRef = /*#__PURE__*/forwardRef(SvgOval62ASelected);
export default ForwardRef;